import React from 'react';
import { FormBuilder } from 'commons-ui';
import useEdit from './useEdit';
import {
	GST_OFFER_UPDATE_CONFIG,
	EDIT_GST_FORM_LAYOUT_CONFIG,
	FORM_FIELD_CONFIG,
	validationSchemaEdit
} from '../../utils/formConfig';

const EditOffer: React.FC<{}> = () => {
	const { data, showLoader, handleFormSubmit, handleFormCancel, setShowLoader } = useEdit();
	FORM_FIELD_CONFIG.segmentName.renderProps.options = [{ id: data?.segmentName, label: data?.segmentName }];
	return (
		<FormBuilder
			data={data}
			mode='edit'
			showLoader={showLoader}
			handleFormSubmit={handleFormSubmit}
			handleFormCancel={handleFormCancel}
			setShowLoader={setShowLoader}
			fieldConfig={GST_OFFER_UPDATE_CONFIG}
			layoutConfig={EDIT_GST_FORM_LAYOUT_CONFIG}
			validationSchema={validationSchemaEdit}
		/>
	);
};

export default EditOffer;
